module.exports = __webpack_public_path__ + "img/logo.5c5d3a5c.png";